import React from 'react'
import Lottie from 'lottie-react'
import dotSpinner from './dotSpinner.json'
import circularSpinner from './circularSpinner.json'
import * as Styled from './styles'
import ProgressIndicator from '@veneer/core/dist/scripts/progress_indicator'
import { useSignupSession } from '../../../hooks'

export const LoadingPage = () => {
  const { isHpx, enableHpxCircularSpinner } = useSignupSession()

  if (isHpx) {
    return (
      <Styled.HpxContainer data-testid="hpx-loading-page">
        <div>
          {enableHpxCircularSpinner ? (
            <Lottie animationData={circularSpinner} />
          ) : (
            <Lottie animationData={dotSpinner} />
          )}
        </div>
      </Styled.HpxContainer>
    )
  }

  return (
    <Styled.Container data-testid="progress-indicator-container">
      <ProgressIndicator />
    </Styled.Container>
  )
}
